export const CHASSIS_REGEX = /^[0-9a-hj-npr-zA-HJ-NPR-Z]{13}[0-9]{4}$/;

export default function chassis(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (CHASSIS_REGEX.test(value)) {
    return false;
  }

  return true;
}

chassis.message = function message(value, options = {}) {
  return options.message || 'precisa ser um chassi válido';
};
